import { create } from 'zustand';

import { MessagesControllerGetQueryResponse } from '~/shared/api/generated';

type MessagesStore = {
  messages: MessagesControllerGetQueryResponse[];
  addMessages: (message: MessagesControllerGetQueryResponse) => void;
  loadMessages: (messages: MessagesControllerGetQueryResponse[]) => void;
  getMessages: (chatId: string) => MessagesControllerGetQueryResponse[];
};

export const useSupportPageMessages = create<MessagesStore>((set, get) => ({
  messages: [],
  addMessages: (message) =>
    set((state) => ({
      ...state,
      messages: [...state.messages, message],
    })),
  loadMessages: (messages) =>
    set((state) => ({
      ...state,
      messages,
    })),
  getMessages: (chatId) => {
    const { messages } = get();
    return messages.filter((message) => message.chat.id === chatId);
  },
}));
